
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M42 11.5v17.715h-8.078l3.567 12.068-12.99-12.068v-17.71zM20.5 11.495v17.72h-8.15l3.567 12.068-12.99-12.068V11.5z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#234652","stroke-width":"1.021","d":"M44.49 9.228v17.21h-8.983l.193.654 3.04 10.281-11.463-10.648V9.232zm-21.577 0v17.21h-8.979l.194.654 3.04 10.281L5.704 26.725V9.232z"}})])
          )
        }
      }
    